export default "__VITE_ASSET__Dal7mg_m__"